import { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import axios from "axios";
import "./Feedback.css";
import { useMsal } from "@azure/msal-react";
import "./AnalyticsPage.css";
import { baseURL } from "../Constant";
// const baseURL = "http://localhost:3002";
// const baseURL =
//   "https://atci.entrylevellearning.accenture.com/techexpress-apis";

function getModalStyle() {
  const top = "10%";
  const left = "30%";

  return {
    top: "10%",
    left: "32%",
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 600,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

export default function FeedbackContent() {
  {
    /* For FAQ Bot */
  }
  const [showImage, setShowImage] = useState(false);
  const [showImageTwo, setShowImageTwo] = useState(false);
  const [data, setData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  let loggedInEnterpriseId = "";

  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;

  const lkmPagesAnalytics = () => {
    axios
      .post(
        `${baseURL}/analyticschatuser`,
        {
          enterprise_id: loggedInEnterpriseId,
        },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        getAnalytics();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getAnalytics = () => {
    axios
      .get(`${baseURL}/analyticschat`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setData(response.data);
        // setTotalViews(response.data.totalViews);
        // setTotalUserViews(response.data.totalUniqueUsers);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getAnalytics();
  }, []);
  const toggleImage = () => {
    const nextState = !isOpen;
    setIsOpen(nextState);

    if (nextState) {
      lkmPagesAnalytics();
    }

    setShowImage(!showImage);
  };

  const toggleImageTwo = () => {
    setShowImageTwo(!showImageTwo);
  };
  {
    /*  ===== */
  }
  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);
  const [open, setOpen] = useState(false);
  const [answer1, setAnswer1] = useState("");
  const [answer2, setAnswer2] = useState("");
  const [answer3, setAnswer3] = useState("");
  const [toggle, setToggle] = useState(true);
  const [comment, setComment] = useState("");

  const handleOpen = () => {
    setOpen(true);
    setToggle(true);
  };

  const handleClose = () => {
    setOpen(false);
    setToggle(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setToggle(false);
    try {
      axios({
        method: "post",
        url: process.env.REACT_APP_FEEDBACK_URL,
        data: {
          user: activeAccount.name,
          feedback: {
            answer1: answer1,
            answer2: answer2,
            answer3: answer3,
            comment: comment,
          },
        },
      });
    } catch (error) {
      console.log(error);
    }
    setComment("");
  };

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <div className="feedback_label">Feedback</div>
      <hr className="feedback_label_hr" />
      {toggle && (
        <div id="feedback_form">
          <form onSubmit={handleSubmit}>
            <div className="feedback">
              <h6 className="question">
                1. Overall, how satisfied are you with this portal?
              </h6>
              <div className="radio_button">
                <label className="feedback-label">
                  <input
                    name="question1"
                    type="radio"
                    value="Excellent"
                    onChange={(event) => {
                      setAnswer1(event.target.value);
                    }}
                  />{" "}
                  Excellent{" "}
                </label>
                <label className="feedback-label">
                  <input
                    name="question1"
                    type="radio"
                    value="Very Good"
                    onChange={(event) => {
                      setAnswer1(event.target.value);
                    }}
                  />{" "}
                  Very Good{" "}
                </label>
                <label className="feedback-label">
                  <input
                    name="question1"
                    type="radio"
                    value="Good"
                    onChange={(event) => {
                      setAnswer1(event.target.value);
                    }}
                  />{" "}
                  Good{" "}
                </label>
              </div>
              <h6 className="question">
                2. Please, rate the learning resources available on the portal.
              </h6>
              <div className="radio_button">
                <label className="feedback-label">
                  <input
                    name="question2"
                    type="radio"
                    value="Excellent"
                    onChange={(event) => {
                      setAnswer2(event.target.value);
                    }}
                  />{" "}
                  Excellent{" "}
                </label>
                <label className="feedback-label">
                  <input
                    name="question2"
                    type="radio"
                    value="Very Good"
                    onChange={(event) => {
                      setAnswer2(event.target.value);
                    }}
                  />{" "}
                  Very Good{" "}
                </label>
                <label className="feedback-label">
                  <input
                    name="question2"
                    type="radio"
                    value="Good"
                    onChange={(event) => {
                      setAnswer2(event.target.value);
                    }}
                  />{" "}
                  Good{" "}
                </label>
                <br />
              </div>
              <h6 className="question">
                3. To what extent this skill journey helped you to upskill
                yourself?
              </h6>
              <div className="radio_button">
                <label className="feedback-label">
                  <input
                    name="question3"
                    type="radio"
                    value="Excellent"
                    onChange={(event) => {
                      setAnswer3(event.target.value);
                    }}
                  />{" "}
                  Excellent{" "}
                </label>
                <label className="feedback-label">
                  <input
                    name="question3"
                    type="radio"
                    value="Very Good"
                    onChange={(event) => {
                      setAnswer3(event.target.value);
                    }}
                  />{" "}
                  Very Good{" "}
                </label>
                <label className="feedback-label">
                  <input
                    name="question3"
                    type="radio"
                    value="Good"
                    onChange={(event) => {
                      setAnswer3(event.target.value);
                    }}
                  />{" "}
                  Good{" "}
                </label>
              </div>
              <label for="exampleFormControlTextarea1">
                {" "}
                <h6 className="textarea-label">Your Comment</h6>{" "}
              </label>
              <textarea
                id="exampleFormControlTextarea1"
                rows="3"
                onChange={(event) => {
                  setComment(event.target.value);
                }}
              >
                {comment}
              </textarea>
              <div className="submit">
                <button type="submit">Submit</button>
                <button type="button" onClick={handleClose}>
                  Close
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
      {!toggle && (
        <div id="success_form">
          <h5 className="feedback-success">Submitted Successfully</h5>
          <div className="success-submit">
            <button type="button" onClick={handleClose}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );

  return (
    <div>
      {/* <div className='feedback-button'>
        <button type="button" onClick={handleOpen}>
            Feedback
        </button>
      </div>      
      <Modal open={open} aria-labelledby="simple-modal-tile" aria-describedby="simple-modal-description">
        {body}
      </Modal> */}

      <div id="" class="mySidenav">
        <div>
          <a
            href="https://deepknowledge.accenture.com/course/view.php?id=574"
            target="_blank"
            id="letsPlay"
          >
            <img src="/images/Lets_play_Icon.png" alt="" />
            Let's Play!
          </a>

          {/* <button type="button" onClick={handleOpen} id="feedback"><img src='/images/Feedback_Icon.png'/>Feedback</button>
      <Modal open={open} aria-labelledby="simple-modal-tile" aria-describedby="simple-modal-description">
        {body}
      </Modal> */}
        </div>
      </div>

      {/*Virtual FAQ Bot modification

       chat bot */}

       {/*    <div className="chat-bot">
        {showImage && (
          <iframe
            title="testing"
            src="https://webchat.botframework.com/embed/ASEFAQBotLanguage-bot/gemini?b=ASEFAQBotLanguage-bot&s=Ej90ws9JziGgLegU6KbgvOVkulxPDQ8U9DzdYmtDkYylDmoya2CCJQQJ99BBAC5RqLJAArohAAABAZBS1Wu4.DvK8Mr0i2N6HyFTjwjQvmYaDWimB4uyYYYfakQotzUGop8LUHFGZJQQJ99BEACGhslBAArohAAABAZBS1Wf3&username=You"

            style={{ width: "100%", height: "200px" }}
          ></iframe>
        )}

        <button onClick={toggleImage} className="chat-bot-btn">
          {" "}
          <img src="/images/ASE.png" className="iconbot" />
          FAQ for ASE
        </button>
      </div> */}

      {/*  <div className="chat-bot-two">
        {showImageTwo && (
          <iframe
            title="testing"
            src="https://webchat.botframework.com/embed/BusinessFAQBotLanguage-bot/gemini?b=BusinessFAQBotLanguage-bot&s=G3WaTjkXiuuDvfV60m4TgS9WNU9Y6f44TeV8y9PiXZLaQyMEW7cRJQQJ99BBACGhslBAArohAAABAZBSq4Ez.3fhdyJV265dUstM4wbxK6OwE0yFv7TknAceYQr4OnbHt7ImANTKEJQQJ99BBACGhslBAArohAAABAZBS3rJx&username=You"
           // src="https://webchat.botframework.com/embed/GFTLKMVirtualBusiness-bot?s=7GtNX8eu8Yo._F3ogIPnTMrCjKSdPpjpV66GWDO4Nbwi7shWgYcfPSE"
            style={{ width: "100%", height: "200px" }}
          ></iframe>
        )}
        <button onClick={toggleImageTwo} style={{height:"35px"}} className="chat-bot-btn"><img src="/images/SME.png" className="iconbot" />FAQ for Business</button> 
      </div> */}
    </div>
  );
}
